import PageShell from "@/components/PageShell";
import IstresMap from "@/components/IstresMap";
import CityMiniDirectory from "@/components/home/CityMiniDirectory";
import { MapPin } from "lucide-react";

export default function PlanPage() {
  return (
    <PageShell>
      <section className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8 py-10 sm:py-14">
        <div className="mb-8 sm:mb-10 max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-plum-100 text-plum-700 mb-3 text-[12px] font-bold uppercase tracking-wider">
            <MapPin size={12} strokeWidth={2.5} /> Plan d&apos;Istres
          </div>
          <h1 className="heading-display text-[2rem] sm:text-[2.6rem] text-plum-900 leading-[1.1]">
            Tout ce qu&apos;il faut, au bon endroit.
          </h1>
          <p className="mt-3 text-[16px] text-plum-700/75">
            Commerces, parkings, défibrillateurs, marchés, dépose-minute — affichez ce que vous cherchez en un clic.
          </p>
        </div>
        <IstresMap />
        <CityMiniDirectory />
      </section>
    </PageShell>
  );
}
